<script setup lang="ts">

</script>

<template>
  <div class="local-loader" />
</template>

<style scoped lang="scss">
.local-loader {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 3px solid var(--purple-purple80);
  border-top: 2px solid transparent;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>